import {Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, OnDestroy} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {MenuItems} from '../../shared/menu-items/menu-items';
import {Subscription} from 'rxjs/Subscription';
import {MdListModule} from '@angular/material';
import {MdSidenavModule} from '@angular/material';
import { SharedService } from '../../shared/services/share.services';
import { AppConstants } from '../../shared/constants/constants';
import { environment } from '../../../environments/environment';
@Component({
  selector   : 'app-layout',
  templateUrl: './layout.component.html',
  providers: [SharedService]

})
export class LayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('sidemenu') sidemenu; // : MdSidenav;
  @ViewChild('header') header;
  @ViewChild('appmenu') appmenu;
  footer: string;
  public subscription: Subscription;
  public centreSubscription: Subscription;

  public version = '';

  constructor(public sharedService: SharedService) {
      // get current user info to update user name in header (fix bug SD10001680-268)
      this.subscription = this.sharedService.getUserInfoUpdate().subscribe(
        data => {
         this.header.updateUserInfo(data);
      });

      // get current centre info to update centre name and image in header (fix bug SD10001680-268)
      this.centreSubscription = this.sharedService.getCentreInfoUpdate().subscribe(
        data => {
         this.header.updateCentreInfo(data);
      });

      this.version = environment.versionTMB;
  }

  ngOnInit(): void {
    this.footer = localStorage.getItem(AppConstants.localStorage.buildVersion);
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {
    this.sidemenu.onClose.subscribe(() => {
      this.emitAnimationEnd();
    });
    this.sidemenu.onOpen.subscribe(() => {
      this.emitAnimationEnd();
    });
  }

  emitAnimationEnd() {
    this.sharedService.announceMenuToggle();
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/layout/layout.component.ts